import type { IconProps } from './../../models/icon';

export function UmbrellaIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M3.42871 12C3.42871 9.72674 4.33176 7.54656 5.93923 5.93911C7.54668 4.33164 9.72686 3.42859 12.0001 3.42859C14.2734 3.42859 16.4536 4.33164 18.061 5.93911C19.6685 7.54656 20.5716 9.72674 20.5716 12H3.42871Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M3.42871 12C3.42871 9.72674 4.33176 7.54656 5.93923 5.93911C7.54668 4.33164 9.72686 3.42859 12.0001 3.42859C14.2734 3.42859 16.4536 4.33164 18.061 5.93911C19.6685 7.54656 20.5716 9.72674 20.5716 12H3.42871Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12 3.42861V0.857178"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M17.1429 20.5714C17.1429 21.2534 16.8719 21.9075 16.3897 22.3898C15.9075 22.872 15.2534 23.1429 14.5714 23.1429C13.8895 23.1429 13.2354 22.872 12.7532 22.3898C12.2709 21.9075 12 21.2534 12 20.5714V12"
      />
    </svg>
  );
}
